<template>
  <div @click="goDetail" class="course-card">
    <div class="card-top">
      <div class="course-name">{{ courseData.course_name }}</div>
      <div class="course-btn">
        <div class="icon"></div>
      </div>
    </div>
    <div class="card-info">
      <span class="teacher">{{ courseData.lecturer }}</span>
      <span class="organ">{{ courseData.organ_name }}</span>
    </div>
    <div class="course-img">
      <img :src="courseData.course_cover_url || require('@/assets/images/common/course_cover.png')" />
    </div>
  </div>
</template>
<script>
import { handleLogin } from '@/plugins/utils'
export default {
  props: {
    courseData: {
      required: true,
      type: Object
    },
    showLabel: {
      required: false,
      type: Boolean,
      default: false
    },
    labelContent: {
      required: false,
      type: String,
      default: 'course_type_name'
    },
    cols: {
      required: false,
      type: String,
      default: 'n + 3'
    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number
  },
  methods: {
    goDetail() {
      if (this.authType == 2 && !this.userInfo) {
        handleLogin()
      } else {
        window.open(this.courseData.course_url)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.course-card {
  cursor: pointer;
  position: relative;
  background-color: #F7F8FA;
  border-radius: 12px;
  padding: 16px;
  font-family: "PingFang SC";
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  &:hover {
    background-color: #fff;
    // 阴影效果
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    .course-img {
      img {
        transition: all 0.5s;
        transform: scale(1.05);
      }
    }
    .card-top {
      .course-name {
        color: #194189;
      }
      .course-btn {
        .icon {
          animation: btnFadeIn 0.3s ease-in-out;
          background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/736f0226263b49caa558edee6937eabf.png');
        }
      }
    }
  }
  .card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 16px;
    .course-name {
      color: #1C212A;
      font-size: 16px;
      font-weight: 500;
      width: 80%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .course-btn {
      width: 28px;
      height: 28px;
      .icon {
        width: 100%;
        height: 100%;
        background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/a8446b0a36e9499a9a10553b10f9008f.png');
        background-size: 100% 100%;
      }
    }
  }
  .card-info {
    margin-top: 8px;
    height: 22px;
    .teacher {
      color: #1C212A;
      font-size: 12px;
      font-weight: 400;
    }
    .organ {
      color: #84909D;
      font-size: 12px;
      font-weight: 400;
      &::before {
        content: "|";
        margin: 0 10px;
      }
    }
  }
  .course-img {
    margin-top: 12px;
    box-sizing: border-box;
    width: 100%;
    height: 145px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 12px;
    }
  }
  @keyframes btnFadeIn {
    0% {
      opacity: 0;
      width: 0;
      height: 100%;
    }
    100% {
      opacity: 1;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
